<template>
  <v-container class="pa-0">
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      v-if="current"
      :disabled="current.status && current.status !== 'draft'"
    >
      <v-row class="text-center" justify="center">
        <v-col cols="12" sm="12" md="12">
          <v-card
            :class="this.$vuetify.breakpoint.mobile ? '' : 'pa-15'"
            :elevation="1"
          >
            <v-container class="text-left">
              <v-row>
                <v-col cols="12" sm="8" class="text-left">
                  <img
                    src="/heig.png"
                    alt="Logo HEIG-VD"
                    :height="this.$vuetify.breakpoint.mobile ? 50 : 100"
                  />
                </v-col>
                <v-col cols="12" sm="4" class="text-right">
                  <div class="headline">BON DE COMMANDE</div>
                </v-col>
              </v-row>
            </v-container>
            <v-card-text>
              <v-text-field
                dense
                outlined
                label="Acronyme employé *"
                :value="current.creatorTla"
                @input="
                  (value) => {
                    updateField('creatorTla', value.toUpperCase());
                  }
                "
                :rules="[validation.required, validation.creatorTla]"
                maxlength="3"
                required
              ></v-text-field>
              <v-select
                dense
                outlined
                label="Commandé par"
                :value="current.buyer"
                :items="buyers"
                @input="
                  (value) => {
                    updateField('buyer', value);
                  }
                "
              ></v-select>
              <v-text-field
                dense
                outlined
                :label="`Adresse e-mail du fournisseur ${
                  current.buyer === 'Service Finance' ? '*' : ''
                }`"
                :value="current.supplierEmail"
                :rules="
                  current.buyer !== 'Service Finance'
                    ? [validation.supplierEmail]
                    : [validation.required, validation.supplierEmail]
                "
                :required="current.buyer === 'Service Finance'"
                @input="
                  (value) => {
                    updateField('supplierEmail', value);
                  }
                "
              ></v-text-field>
              <v-textarea
                dense
                outlined
                label="Adresse du fournisseur *"
                :value="current.supplier"
                :rules="[validation.required]"
                rows="3"
                auto-grow
                required
                @input="
                  (value) => {
                    updateField('supplier', value);
                  }
                "
              ></v-textarea>
              <v-textarea
                dense
                outlined
                label="Adresse de livraison *"
                :value="current.delivery"
                :rules="[validation.required]"
                rows="3"
                auto-grow
                @input="
                  (value) => {
                    updateField('delivery', value);
                  }
                "
              ></v-textarea>
              <v-text-field
                dense
                outlined
                label="No de client"
                :value="current.clientNumber"
                @input="
                  (value) => {
                    updateField('clientNumber', value);
                  }
                "
              ></v-text-field>
              <v-text-field
                dense
                outlined
                label="No et nom du projet"
                :value="current.projectNumber"
                @input="
                  (value) => {
                    updateField('projectNumber', value);
                  }
                "
              ></v-text-field>
              <v-container class="text-left pa-0">
                <v-row>
                  <v-col cols="12" sm="6" class="text-left">
                    <v-text-field
                      dense
                      outlined
                      label="Selon offre réf."
                      :value="current.offerRef"
                      @input="
                        (value) => {
                          updateField('offerRef', value);
                        }
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-right">
                    <v-text-field
                      outlined
                      label="du"
                      v-model="displayOfferRefDate"
                      :rules="[validation.date]"
                      v-mask="['##.##.####']"
                      hint="Format attendu JJ.MM.AAAA"
                      dense
                    />
                  </v-col>
                </v-row>
              </v-container>
              <div class="mb-5">
                <ItemsTable />
              </div>
              <v-container class="text-left pa-0">
                <v-row>
                  <v-col cols="12" sm="8" class="text-left">
                    <v-text-field
                      dense
                      outlined
                      label="Montant *"
                      :value="
                        typeof current.value === 'number'
                          ? current.value.toFixed(2)
                          : current.value
                      "
                      :rules="[validation.required, validation.value]"
                      type="number"
                      step="0.01"
                      min="0"
                      max="9999999.99"
                      :hint="
                        this.current.currency !== 'CHF'
                          ? `Estimation : CHF ${(
                              this.current.value /
                              this.rates[this.current.currency]
                            ).toFixed(2)}`
                          : ''
                      "
                      :persistent-hint="
                        this.current.currency !== 'CHF' && !!this.current.value
                      "
                      @input="
                        (value) => {
                          updateField('value', value);
                        }
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" class="text-right">
                    <v-select
                      dense
                      outlined
                      label="Devise"
                      :value="current.currency"
                      :items="currencies"
                      :item-text="(item) => `${item.name} (${item.code})`"
                      item-value="code"
                      @input="
                        (value) => {
                          updateField('currency', value);
                        }
                      "
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <v-text-field
                dense
                outlined
                label="À l'attention de"
                :value="current.recipient"
                @input="
                  (value) => {
                    updateField('recipient', value);
                  }
                "
              ></v-text-field>
              <v-text-field
                dense
                outlined
                label="Année *"
                :value="current.year"
                :rules="[validation.required, validation.year]"
                maxlength="4"
                @input="
                  (value) => {
                    updateField('year', value);
                  }
                "
              ></v-text-field>
              <v-text-field
                dense
                outlined
                label="Compte"
                :value="current.account"
                :rules="[validation.account]"
                maxlength="7"
                @input="
                  (value) => {
                    updateField('account', value);
                  }
                "
              ></v-text-field>
              <v-text-field
                dense
                outlined
                label="Centre de coût"
                :value="current.costCenter"
                :rules="[validation.costCenter]"
                maxlength="5"
                @input="
                  (value) => {
                    updateField('costCenter', value);
                  }
                "
              ></v-text-field>
              <v-text-field
                dense
                outlined
                label="Date du bon de commande"
                v-model="displayPoDate"
                :rules="[validation.date]"
                v-mask="['##.##.####']"
                hint="Format attendu JJ.MM.AAAA"
                @input="
                  (value) => {
                    updateField('date', value);
                  }
                "
              ></v-text-field>
              <v-textarea
                dense
                outlined
                label="Remarques"
                :value="current.comments"
                rows="3"
                auto-grow
                maxlength="160"
                counter="160"
                @input="
                  (value) => {
                    updateField('comments', value);
                  }
                "
              ></v-textarea>
              <v-file-input
                dense
                outlined
                accept=".pdf"
                :label="
                  current.value <= 50000
                    ? 'Scan de l\'offre'
                    : 'Scan de l\'offre *'
                "
                :rules="current.value <= 50000 ? [] : [validation.required]"
                @change="handleOfferUpload"
                @click:clear="removeOffer"
                :loading="offerUploading"
                hint="Fichiers en format PDF"
                :persistent-hint="true"
              ></v-file-input>
              <div
                class="text-left mb-4"
                v-if="this.$route.name === 'Admin' && current.offer"
              >
                Fichier actuel :
                <a @click="downloadFile(current.offer)">{{ current.offer }}</a>
              </div>
              <v-file-input
                v-if="current.value >= 100000"
                dense
                outlined
                accept=".pdf"
                label="Scan du document pour les commandes de plus de CHF 100'000.-"
                @change="handleDocumentUpload"
                @click:clear="removeDocument"
                :loading="documentUploading"
                hint="Fichiers en format PDF"
                :persistent-hint="true"
              ></v-file-input>
              <div
                class="text-left mb-4"
                v-if="this.$route.name === 'Admin' && current.document"
              >
                Fichier actuel :
                <a @click="downloadFile(current.document)">{{
                  current.document
                }}</a>
              </div>
            </v-card-text>

            <div v-if="current.orderId">
              <v-divider></v-divider>
              <div class="my-10">
                <div>
                  Bon de commande
                  <span class="title"
                    >{{ current.orderId }}{{ current.creatorTla }}</span
                  >
                  généré.
                </div>
                <div>
                  Vous pouvez le télécharger en cliquant sur le lien ci-dessous.
                </div>
                <div v-if="!generating">
                  <a @click="downloadBinder(current.binder)"
                    >{{ current.orderId
                    }}{{ current.creatorTla }}-bon-de-commande.pdf</a
                  >
                </div>
                <div v-else>Génération du bon de commande...</div>
              </div>
              <v-divider></v-divider>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="generatePurchaseOrder"
                :disabled="
                  !requiredFields ||
                  (current.status && current.status !== 'draft') ||
                  generating
                "
                >{{
                  current._id
                    ? "Mettre à jour le bon de commande"
                    : "Générer le bon de commande"
                }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { parse, parseISO, formatISO, format, isSameDay } from "date-fns";
import axios from "axios";
import FileDownload from "js-file-download";
import { mask } from "vue-the-mask";
import ItemsTable from "@/components/ItemsTable";

export default {
  directives: { mask },
  components: { ItemsTable },
  data: () => ({
    displayPoDate: "",
    displayOfferRefDate: "",
    valid: false,
    buyers: ["Requérant", "Service Finance"],
    currencies: [
      { name: "Franc suisse", code: "CHF" },
      { name: "Euro", code: "EUR" },
      { name: "Dollar américain", code: "USD" },
      { name: "Livre sterling", code: "GBP" },
    ],
    rates: {},
    validation: {
      required: (value) => !!value || "Ce champ est requis.",
      creatorTla: (value) => {
        const pattern = /^[a-zA-Z]*$/;
        return (
          (pattern.test(value) && value.length === 3) ||
          "Votre acronyme est composé de 3 lettres."
        );
      },
      supplierEmail: (value) => {
        if (value) {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Adresse e-mail non valide.";
        }
        return true;
      },
      value: (value) => {
        const pattern = /^\d+(\d{3})*(\.\d{2,2})?$/;
        return pattern.test(value) || "Veuillez respecter le format 00.00";
      },
      year: (value) => {
        const pattern = /^[0-9]*$/;
        return (
          (pattern.test(value) && value.length === 4) ||
          "L'année doit être composé de 4 chiffres."
        );
      },
      costCenter: (value) => {
        if (value) {
          const pattern = /^[0-9]*$/;
          return (
            (pattern.test(value) && value.length === 5) ||
            "Le centre de coût doit être composé de 5 chiffres."
          );
        }
        return true;
      },
      account: (value) => {
        if (value) {
          const pattern = /^[0-9]*$/;
          return (
            (pattern.test(value) && value.length === 7) ||
            "Le compte doit être composé de 7 chiffres."
          );
        }
        return true;
      },
      date: (value) => {
        if (value) {
          const parsed = parse(value, "dd.MM.yyyy", new Date());
          if (parsed.toString() !== "Invalid Date" && value.length === 10) {
            return true;
          }

          return "Format attendu JJ.MM.AAAA";
        }
        return true;
      },
    },
    format,
    parseISO,
  }),
  computed: {
    ...mapState({
      current: (state) => state.orders.current,
      loading: (state) => state.orders.loading,
      generating: (state) => state.orders.generating,
      offerUploading: (state) => state.orders.offerUploading,
      documentUploading: (state) => state.orders.documentUploading,
    }),
    requiredFields: function () {
      return (
        !!this.current.supplier &&
        !!this.current.delivery &&
        !!this.current.value &&
        !!this.current.year &&
        !!this.current.creatorTla
      );
    },
  },
  methods: {
    ...mapActions("orders", [
      "loadOrder",
      "initOrder",
      "updateCurrent",
      "createOrder",
      "updateOrder",
      "uploadOffer",
      "uploadDocument"
    ]),
    ...mapActions("validations", [
      "loadValidation",
    ]),
    updateField: function (fieldname, value) {
      this.updateCurrent({ fieldname, value });
    },
    handleOfferUpload: async function (file) {
      this.uploadOffer(file)
    },
    handleDocumentUpload: async function (file) {
      this.uploadDocument(file)
    },
    generatePurchaseOrder: async function () {
      this.current._id
        ? this.updateOrder(this.current)
        : this.createOrder(this.current);
    },
    removeDocument: function () {
      this.current.document = "";
    },
    removeOffer: function () {
      this.current.offer = "";
    },
    downloadBinder: async function (filename) {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/files/${filename}`,
        responseType: "arraybuffer",
      });
      FileDownload(
        data,
        `${this.current.orderId}${this.current.creatorTla}-bon-de-commande.pdf`
      );
    },
    downloadFile: async function (filename) {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/files/${filename}`,
        responseType: "arraybuffer",
      });
      FileDownload(data, filename);
    },
  },
  watch: {
    "$route.params": function (after) {
      const { _id } = after;
      if (_id) {
        this.$route.name === 'Orders Details' ? this.loadOrder(_id) : this.loadValidation(_id);
      } else {
        this.initOrder();
      }
    },
    "$route.fullPath": function (after) {
      if (after === "/orders/create") {
        this.$refs.form.resetValidation();
      }
    },
    displayPoDate: function (after) {
      if (after.length === 10) {
        this.updateField(
          "poDate",
          formatISO(parse(after, "dd.MM.yyyy", new Date()))
        );
      }
    },
    "current.poDate": function (after, before) {
      if (!isSameDay(parseISO(after), parseISO(before))) {
        this.displayPoDate = format(parseISO(after), "dd.MM.yyyy");
      }
    },
    displayOfferRefDate: function (after) {
      if (after.length === 10) {
        this.updateField(
          "offerRefDate",
          formatISO(parse(after, "dd.MM.yyyy", new Date()))
        );
      }
    },
    "current.offerRefDate": function (after, before) {
      if (after && !isSameDay(parseISO(after), parseISO(before))) {
        this.displayOfferRefDate = format(parseISO(after), "dd.MM.yyyy");
      }
    },
  },
  async mounted() {
    const { _id } = this.$route.params;
    if (_id) {
      this.$route.name === 'Orders Details' ? this.loadOrder(_id) : this.loadValidation(_id);
    } else {
      this.initOrder();
    }
    const symbols = this.currencies.map((c) => c.code).join(",");
    const { data } = await axios({
      method: "get",
      url: `https://api.exchangeratesapi.io/latest?base=CHF&symbols=${symbols}`,
    });
    this.rates = data.rates;
  },
};
</script>